import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseGroupIcon } from 'assets/images/group.svg';
import { ReactComponent as BaseUserIcon } from 'assets/images/user.svg';
import Button from 'components/Buttons/Button';

type FilterButtonProps = {
  $active: boolean;
};

export const Container = styled.div`
  margin-bottom: 80px;
`;

export const ButtonContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    position: sticky;
    bottom: 0;
    margin-top: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.usersList.cardBackground};
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
  }
`;

export const StyledButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0px 16px 32px 16px;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 32px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 20px;
  margin-bottom: 8px;
`;

export const UserIcon = styled(BaseUserIcon)`
  height: 18px;
  margin: 0 8px;
`;

export const GroupIcon = styled(BaseGroupIcon)`
  height: 18px;
  margin: 0 8px;
`;

export const FilterButton = styled.button<FilterButtonProps>`
  display: flex;
  align-items: center;

  font-size: 14px;
  text-align: center;
  padding: 0px 16px;
  height: 36px;

  background: ${({ $active }) => ($active ? ColorPalette.HEX.Seashell : 'none')};
  border: ${({ $active }) => `solid 1px ${$active ? ColorPalette.Transparent : ColorPalette.HEX.Manatee}`};
  color: ${({ $active }) => ($active ? ColorPalette.HEX.OriolesOrange : ColorPalette.HEX.DimGray)};
  border-radius: 12px;
  margin-right: 12px;
  transition: 0.3s;

  ${UserIcon}, ${GroupIcon} {
    color: ${({ $active }) => ($active ? ColorPalette.HEX.PortlandOrange2 : ColorPalette.HEX.DimGray)};
  }
`;
